import { __decorate } from "tslib";
// NPM
import { Component, Mixins } from "vue-property-decorator";
// SYSTEM1
import Loader from "@/components/widgets/loader.vue";
import Layout from "@/router/layouts/main.vue";
import PageHeader from "@/components/page-header.vue";
import BaseMixer from "@/router/views/BaseMixer";
import { ClockWorkModule } from "@/store/modules/clockWork.module";
import SectionLoader from "@/components/widgets/SectionLoader.vue";
import { ProjectReportModel } from "@/store/models/clockWork/projectReport";
import simplebar from "simplebar-vue";
import _ from "lodash";
import EcSelect from "@/components/widgets/EcSelect.vue";
import Switches from "vue-switches";
Component.registerHooks(["metaInfo"]);
let ProjectReport = /** @class */ (() => {
    let ProjectReport = class ProjectReport extends Mixins(BaseMixer) {
        constructor() {
            super(...arguments);
            this.title = "Project Report";
            this.pageIsLoading = false;
            this.isPageLoading = false;
            this.showText = true;
            this.selectedProject = [];
            this.selectedMembers = [];
            this.projectReport = new ProjectReportModel();
            this.showTable = false;
            this.reportType = false;
            this.items = [
                {
                    text: "Home",
                    to: "/dashBoard",
                },
                {
                    text: "Reports",
                },
                {
                    text: "Project Report",
                    active: true,
                },
            ];
        }
        get projectList() {
            return _.sortBy(ClockWorkModule.validProjectReportProjects, (item) => parseInt(item.code));
        }
        get memberList() {
            return ClockWorkModule.projectReportMembers;
        }
        get entries() {
            return ClockWorkModule.projectReportEntries;
        }
        get cumulativeEntries() {
            return ClockWorkModule.cumulativeProjectReportEntries;
        }
        get projectDisplayString() {
            return ClockWorkModule.projectReportProjectDisplayString;
        }
        get totalTime() {
            var totalTimeInSeconds = ClockWorkModule.projectReportTotalTime;
            const hours = Math.floor(totalTimeInSeconds / 3600);
            const minutes = Math.floor((totalTimeInSeconds % 3600) / 60);
            if (hours === 0) {
                return `${minutes}m`;
            }
            else {
                const formattedTime = `${hours}h ${minutes}m`;
                return formattedTime;
            }
        }
        submit() {
            this.validate("validateObserver").then((res) => {
                if (res) {
                    this.pageIsLoading = true;
                    this.showText = false;
                    if (this.projectReport.date[0] != null && this.projectReport.date != undefined) {
                        this.projectReport.startDate = this.projectReport.date[0];
                        this.projectReport.startDateAsString = this.dateFormattedString(this.projectReport.date[0]);
                        this.projectReport.endDate = this.projectReport.date[1];
                        this.projectReport.endDateAsString = this.dateFormattedString(this.projectReport.date[1]);
                        this.projectReport.employeeIds = this.selectedMembers.map((item) => item.id);
                        this.projectReport.isCumulative = this.reportType;
                        ClockWorkModule.GetProjectReport(this.projectReport).then((res) => {
                            if (res) {
                                this.showTable = true;
                                this.pageIsLoading = false;
                            }
                        });
                    }
                }
            });
        }
        GenerateProjectReportAsExcel() {
            this.validate("validateObserver").then((res) => {
                if (res) {
                    this.isPageLoading = true;
                    this.projectReport.startDate = this.projectReport.date[0];
                    this.projectReport.startDateAsString = this.dateFormattedString(this.projectReport.date[0]);
                    this.projectReport.endDate = this.projectReport.date[1];
                    this.projectReport.endDateAsString = this.dateFormattedString(this.projectReport.date[1]);
                    this.projectReport.isCumulative = this.reportType;
                    ClockWorkModule.GetProjectReportAsExcel(this.projectReport).then((res) => {
                        if (res) {
                            const blob = new Blob([res], {
                                type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                            });
                            const link = document.createElement("a");
                            link.href = window.URL.createObjectURL(blob);
                            document.body.appendChild(link);
                            link.download = `ProjectReport.xlsx`;
                            link.click();
                            this.isPageLoading = false;
                        }
                    });
                }
            });
        }
        projectSelectionChanged(selectedObject) {
            this.selectedProject = [selectedObject];
            this.selectedMembers = [];
            this.projectReport.projectId = selectedObject.id.toString();
            ClockWorkModule.GetProjectMembersForReport(selectedObject.id);
        }
        memberSelectionChanged(selectedObjects) {
            if (selectedObjects.id == this.emptyGuid) {
                this.selectedMembers = [];
                this.selectedMembers.push(selectedObjects);
            }
            else {
                this.selectedMembers = this.selectedMembers.filter((x) => x.id != this.emptyGuid);
                this.selectedMembers.push(selectedObjects);
            }
        }
        clearDatePicker() {
            ClockWorkModule.ClearProjectReportData();
        }
        clearReport() {
            this.showTable = false;
            this.projectReport = new ProjectReportModel();
            this.showText = true;
            this.selectedProject = [];
            this.selectedMembers = [];
            this.reportType = false;
            ClockWorkModule.ClearProjectReportData();
        }
        created() {
            ClockWorkModule.GetProjectsForProjectReport();
        }
        destroyed() {
            this.clearDatePicker();
        }
    };
    ProjectReport = __decorate([
        Component({
            name: "ProjectReport",
            components: {
                Loader,
                Layout,
                PageHeader,
                SectionLoader,
                EcSelect,
                simplebar,
                Switches,
            },
        })
    ], ProjectReport);
    return ProjectReport;
})();
export default ProjectReport;
